import Slider from "bootstrap-slider";
import {
    getBookmarkPresentationsByID,
    getLayerByName,
    updateBookmarkPresentationByID,
    updateLayer
} from "@/helpers/ol/ol-layer-helper";
import {update3DTileSetAttribute} from "@/modules/cesium/cesium-service";
import $ from "jquery";

let slider

window.bootstrapSliders = []

/**
 * Initialize the bootstrap plugin slider
 * @param id
 * @param layerName
 */
export function initBootstrapPluginSlider(id, layerName) {
    const element = document.getElementById('slider' + id)
    if(element) {
        new Slider(element).on('slide', function (ev) {
            getLayerByName(layerName, false).setOpacity(ev / 100)
        });
    }
}

/**
 * Initialize the bootstrap slider
 * @param id
 * @param bookmarkPresentationID
 * @param bookmarkPresentations
 */
export function initBoostrapSlider(id, bookmarkPresentationID, bookmarkPresentations = undefined) {
    const element = document.getElementById(id)
    if(element) {
        slider = new Slider(element).on('slideStop', function(ev, ev2){
            if(!bookmarkPresentationID) {
                window.settings.backgroundLayers.map(layerActive => {
                    updateBootstrapSlider(layerActive.BookmarkPresentationID, ev, bookmarkPresentations)
                })
            } else {
                updateBootstrapSlider(bookmarkPresentationID, ev, bookmarkPresentations)
            }
        }).on('slide', function(ev){
            if(!bookmarkPresentationID) {
                window.settings.backgroundLayers.map(layerActive => {
                    updateBootstrapSlider(layerActive.BookmarkPresentationID, ev, bookmarkPresentations)
                })
            } else {
                updateBootstrapSlider(bookmarkPresentationID, ev, bookmarkPresentations)
            }
        });

        window.bootstrapSliders.push({
            slider: slider,
            BookmarkPresentationID: bookmarkPresentationID
        })
    }
}

/**
 * Update the bootstrap slider
 * @param bookmarkPresentationID
 * @param opacity
 * @param bookmarkPresentations
 */
export function updateBootstrapSlider(bookmarkPresentationID, opacity, bookmarkPresentations = undefined) {

    if(opacity) {
        updateBookmarkPresentationByID(bookmarkPresentationID, 'Opacity', opacity / 10)
        updateLayer(bookmarkPresentationID, 'opacity', opacity / 100)
        update3DTileSetAttribute(bookmarkPresentationID, 'opacity', opacity / 100)
        if (window.olCesium) {
            window.olCesium.getCesiumScene().camera.moveBackward(0.0001)
        }
    }

    // Check for presentations with the same name
    if(bookmarkPresentations) {

        const compareBookmarkPresentation = getBookmarkPresentationsByID(bookmarkPresentationID)
        const selectedBookmarkPresentation = bookmarkPresentations.find(bookmarkPresentation => bookmarkPresentation.BookmarkPresentationID === bookmarkPresentationID)
        const sameNamePresentations = bookmarkPresentations.filter(bookmarkPresentation => bookmarkPresentation.DisplayName === selectedBookmarkPresentation.DisplayName && bookmarkPresentation.BookmarkPresentationID !== bookmarkPresentationID)

        sameNamePresentations.map(bookmarkPresentation => {
            if(compareBookmarkPresentation.DefaultOpacity === bookmarkPresentation.DefaultOpacity) {
                const slider = window.bootstrapSliders.find(bootstrapSlider => bootstrapSlider.BookmarkPresentationID === bookmarkPresentation.BookmarkPresentationID)
                slider.slider.setValue(opacity)
                updateBootstrapSlider(bookmarkPresentation.BookmarkPresentationID, opacity)
            }
        })
    }

}
